import { AccessLevel } from "./types";

export function prettyAccessLevel(access_level: AccessLevel) {
  if (access_level === AccessLevel.ReadOnly) {
    return "Read-Only";
  } else if (access_level === AccessLevel.ReadWrite) {
    return "Read-Write";
  } else {
    return access_level;
  }
}
